//import Swal from 'sweetalert2';
//window.Swal= Swal;
//window.swal = require('sweetalert2/dist/sweetalert2.js');
import Swal from 'sweetalert2/dist/sweetalert2.js';
window.Swal= Swal;